// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"3a96c420","312":"f95ecd18","453":"698788f4","457":"a22e2eb9","551":"b35941c5"}[chunkId] + ".chunk.js";
};